/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tts_Tool_Result_Idle_HelpInputs */

const en_tts_tool_result_idle_help = /** @type {(inputs: Tts_Tool_Result_Idle_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate audio to open it in a temporary read-along.`)
};

const es_tts_tool_result_idle_help = /** @type {(inputs: Tts_Tool_Result_Idle_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera audio para abrirlo en una vista temporal de lectura.`)
};

/**
* | output |
* | --- |
* | "Generate audio to open it in a temporary read-along." |
*
* @param {Tts_Tool_Result_Idle_HelpInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const tts_tool_result_idle_help = /** @type {((inputs?: Tts_Tool_Result_Idle_HelpInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tts_Tool_Result_Idle_HelpInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tts_tool_result_idle_help(inputs)
	return en_tts_tool_result_idle_help(inputs)
});